import { useApolloClient } from '@apollo/client';
import { FC, useEffect } from 'react';
import { refreshActiveGateDataWhenVisible } from '../utils/refreshActiveGateData';

/**
 * Refresca los datos de compuerta al recuperar el foco de la pestaña.
 *
 * Vive separado de `GateMessagesSubscription` porque no depende de ninguna compuerta en
 * particular: `refreshActiveGateData` refetchea **todas** las queries activas de compuerta, sin
 * filtrar por `gateId`. Mientras estaba adentro de la suscripción, montar una segunda instancia
 * acotada —la del modal de operación (AMARU-862/US-006)— registraba un segundo listener y
 * duplicaba ese refetch en cada cambio de foco, sin relación con el scope que esa instancia pedía.
 *
 * Se monta **una sola vez**, en `GlobalComponents`.
 */
export const ActiveGateDataRefresher: FC = () => {
  const client = useApolloClient();

  useEffect(() => {
    const handleVisibilityChange = () => {
      void refreshActiveGateDataWhenVisible(client, document.visibilityState);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [client]);

  return null;
};
